import { render, staticRenderFns } from "./PurchaseDetailsModal.vue?vue&type=template&id=3b7e29b4&"
import script from "./PurchaseDetailsModal.vue?vue&type=script&lang=js&"
export * from "./PurchaseDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PurchaseDetailsModal.vue"
export default component.exports